import React from "react";
import { useLocation } from "react-router-dom";
import { IoLogoInstagram } from "react-icons/io5";
import "../styles/navbar.css"

const Navbar = () => {

    const location = useLocation().pathname;

    return (
        <div className="navbar-container">
            <div className="navbar-title-container">
                <h3> Navigation </h3>
            </div>
            <ul className="navbar-links">
                <li> <a href="/homepage"> Startseite </a> </li>
                <li> <a href="/homepage/#/ordinationen" > Ordinationen </a> </li>
                <li> <a href="/homepage/#/termine" > Termine </a> </li>
                <li> <a href="/homepage/#/team"> Team </a> </li>

                {location.startsWith("/team") && (
                    <div className="secondary-links-wrapper">
                        <li className="secondary-link"><a href="/homepage/#/team/csebald">Dr. Claudia Sebald</a></li>
                        <li className="secondary-link"><a href="/homepage/#/team/lehrpraxis">Absolventen Lehrpraxis</a></li>
                    </div>
                )}

                <li> <a href="/homepage//#/leistungen"> Leistungen </a> </li>
                {location.startsWith("/leistungen") && ( 
                    <div className="secondary-links-wrapper">
                        <li className="secondary-link"><a href="/homepage/#/leistungen/diabetes">Diabetes im Griff</a></li>
                        <li className="secondary-link"><a href="/homepage/#/leistungen/impfen">Impfberatung</a></li>
                        <li className="secondary-link"><a href="/homepage/#/leistungen/ekg">EKG</a></li>
                        <li className="secondary-link"><a href="/homepage/#/leistungen/ergometrie">Ergometrie</a></li>
                        <li className="secondary-link"><a href="/homepage/#/leistungen/echokardiographie">Echokardiographie-Herzultraschall</a></li>
                        <li className="secondary-link"><a href="/homepage/#/leistungen/carotis">Carotis Ultraschall</a></li>
                        <li className="secondary-link"><a href="/homepage/#/leistungen/schilddruese">Schilddrüsenuntersuchung</a></li>
                        <li className="secondary-link"><a href="/homepage/#/leistungen/opf">OP Freigabe</a></li>
                        <li className="secondary-link"><a href="/homepage/#/leistungen/schrittmacher">Schrittmacherkontrolle - NEU</a></li>
                        <li className="secondary-link"><a href="/homepage/#/leistungen/patientenverfuegung">Medizinisches Patientenverfügungs-Beratungsgespräch</a></li>
                        <li className="secondary-link"><a href="/homepage/#/leistungen/raucherentwoehnung">Raucherentwöhnung</a></li>
                        <li className="secondary-link"><a href="/homepage/#/leistungen/24stunden_ekg">24 Stunden EKG</a></li>
                        <li className="secondary-link"><a href="/homepage/#/leistungen/24stunden_blutmessung">24-Stunden Blutdruckmessung</a></li>
                        <li className="secondary-link"><a href="/homepage/#/leistungen/herzinsuffizienz">Herzinsuffizienztherapieoptimierung</a></li>
                        <li className="secondary-link"><a href="/homepage/#/leistungen/vorsorge">Vorsorgeuntersuchung</a></li>
                        <li className="secondary-link"><a href="/homepage/#/leistungen/tauchen">Tauchtauglichkeitsuntersuchungen, ÖGTH</a></li>
                   </div>
                )}
                <li> <a href="/homepage/#/kontakt"> Kontakt </a> </li>

                <li> <a href="/homepage/#/kontakt/terminanfrage"> Terminanfrage </a> </li>
                <li> <a href="/homepage/#/kontakt/rezeptbestellung"> Rezeptbestellung </a> </li>

                <li> <a href="/homepage/#/jobs"> Jobs / Bewerbung </a> </li>
                <li> <a href="/homepage//#/kurse"> Kurse & Schulungen </a> </li>
                {location.startsWith("/kurse") && (
                    <li className="secondary-link"> <a href="/homepage/#/kurse/reanimation"> Reanimationstraining </a> </li>
                )}

                <li> <a href="/homepage/#/lauf/0"> Laufen & Gesundheit </a> </li>
                {location.startsWith("/lauf") && ( 
                    <div className="secondary-links-wrapper">
                        <li className="secondary-link"><a href="/homepage/#/lauf/0">Rückblick 2026</a></li>
                        <li className="secondary-link"><a href="/homepage/#/lauf/1">Rückblick 2025</a></li>
                        <li className="secondary-link"><a href="/homepage/#/lauf/2">Rückblick 2024</a></li>
                        <li className="secondary-link"><a href="/homepage/#/lauf/3">Rückblick 2023</a></li>
                        <li className="secondary-link"><a href="/homepage/#/lauf/4">Rückblick 2022</a></li>
                        <li className="secondary-link"><a href="/homepage/#/lauf/5">Rückblick 2021</a></li>
                        <li className="secondary-link"><a href="/homepage/#/lauf/6">Rückblick 2018</a></li>
                        <li className="secondary-link"><a href="/homepage/#/lauf/7">Rückblick 2017</a></li>
                    </div>
                )}

                <li> <a href="/homepage/#/hinweise"> Wichtige Hinweise </a> </li>
                <li> <a href="/homepage/#/galerie"> Galerie </a> </li>
                <li> <a href="/homepage/#/links"> Links </a> </li>
                <li> <a href="/homepage/#/store/t-shirts"> T-Shirts </a> </li>
                
            </ul>
            <div id="instgram-link-container"> 
                <IoLogoInstagram id="insta-logo"/> <a href="https://www.instagram.com/herzdoktor_und_kollegium/?hl=en" style={{color:"black", textDecoration:"none"}}> Instagram </a>
            </div>

        </div>
    )
}

export default Navbar;


